import React from "react";
import { useSelector } from "react-redux";

import { IgCheckbox, IgSelect, IgTypography } from "@intelligems/ig-theme";
import {
  CustomEventDto,
  CustomEventsFilterType,
  CustomEventsFilterTypeList,
} from "@intelligems/ig-types";
import { capitalizeFirstLetter } from "@intelligems/ig-utils";
import { CircularProgress, MenuItem } from "@mui/material";
import Grid from "@mui/material/Grid";
import { useGetAllCustomEvents } from "@src/api/custom-events/get-all-custom-events";
import { getCustomMetrics } from "@src/store/slices/experienceMetrics/experienceMetrics";
import { theme } from "@src/theme";

interface CustomEventsFilterProps {
  selectedCustomEventIds: string[];
  onSelect: (id: string) => void;
  customEventsFilterType: CustomEventsFilterType;
  onChange: (value: string, key: string) => void;
  isView?: boolean;
}

export const CustomEventsFilter = ({
  selectedCustomEventIds,
  onSelect,
  customEventsFilterType,
  onChange,
  isView,
}: CustomEventsFilterProps) => {
  const experienceCustomMetrics = useSelector(getCustomMetrics);
  if (!experienceCustomMetrics) {
    return (
      <Grid container justifyContent={"center"}>
        <CircularProgress size={30} />
      </Grid>
    );
  }

  return (
    <Grid container direction={"column"} rowSpacing={2}>
      <Grid container direction={"row"} alignItems={"center"} columnSpacing={1}>
        <Grid>
          <IgTypography
            sx={{
              color: theme.palette.text.secondary,
            }}
          >
            Filter to visitors who triggered{" "}
          </IgTypography>
        </Grid>
        <Grid>
          <IgSelect
            size={"small"}
            sx={{ height: "30px", fontSize: "14px" }}
            variant={"outlined"}
            key={`custom-event-type-filter`}
            value={customEventsFilterType}
            onChange={(e) => {
              onChange(e.target.value, "customEventsFilterType");
            }}
          >
            {CustomEventsFilterTypeList.map((customEventsFilterType) => (
              <MenuItem
                key={`${customEventsFilterType}`}
                value={customEventsFilterType}
              >
                <IgTypography
                  sx={{
                    color: theme.palette.text.secondary,
                  }}
                >
                  {capitalizeFirstLetter(customEventsFilterType)}
                </IgTypography>
              </MenuItem>
            ))}
          </IgSelect>
        </Grid>
        <Grid>
          <IgTypography
            sx={{
              color: theme.palette.text.secondary,
            }}
          >
            {" "}
            any of these events:
          </IgTypography>
        </Grid>
      </Grid>
      <Grid container direction="row">
        {experienceCustomMetrics.map((event, index: number) => (
          <Grid
            container
            key={event.id}
            alignItems="center"
            onClick={() => onSelect(event.customEvent.identifier)}
            sx={{ "& :hover": { cursor: "pointer" } }}
          >
            <IgCheckbox
              sx={{
                color: "rgba(0,0,0,.38)",
                paddingX: "0px",
                marginRight: "9px",
                ...(index === 0 && { paddingTop: 0 }),
              }}
              disabled={isView}
              checked={selectedCustomEventIds.includes(
                event.customEvent.identifier
              )}
            />
            <IgTypography
              sx={{
                ...(index === 0 && { paddingBottom: "10px" }),
              }}
            >
              {event.customEvent.name}
            </IgTypography>
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};
